import {Route} from '../../../../projects/entity-manager/src/lib/decorator/route';

@Route('employee_travel_expense_types')
export class EmployeeTravelExpenseType {
    protected id: string;
    protected code: string;
    protected name: string;

    public setId(id: string): EmployeeTravelExpenseType {
        this.id = id;
        return this;
    }

    public getId(): string {
        return this.id;
    }

    public setCode(code: string): EmployeeTravelExpenseType {
        this.code = code;
        return this;
    }

    public getCode(): string {
        return this.code;
    }

    public setName(name: string): EmployeeTravelExpenseType {
        this.name = name;
        return this;
    }

    public getName(): string {
        return this.name;
    }
}